import { render, staticRenderFns } from "./InvestorProfileModal.vue?vue&type=template&id=40cf4596&scoped=true"
import script from "./InvestorProfileModal.vue?vue&type=script&lang=ts"
export * from "./InvestorProfileModal.vue?vue&type=script&lang=ts"
import style0 from "./InvestorProfileModal.vue?vue&type=style&index=0&id=40cf4596&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cf4596",
  null
  
)

export default component.exports